<template>
  <div class="InvoicePayment" v-if="address">
    <div class="InvoicePayment__cryptos">
      <h3>Payment by USDT / USDC</h3>

      <p>
        Send USDT or USDC (ERC-20 or BEP-20 networks) to the following address:
        <em>{{ address }}</em>
      </p>
      <p>
        Settle from your CFT trading wallet only. Payment from any other wallet will not reconcile with your account and will disrupt the fee calculation. Please reference the invoice number and service period with your transfer.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      invoice: {
        type: Object,
        default: null
      }
    },

    computed: {
      /*
       * Reads invoice.payment, which the API resolves per invoice and
       * server-side: frozen-at-generation value if the invoice has one, else
       * the client's dedicated address, else the shared global one.
       *
       * It deliberately does NOT fall back to
       * invoice.global_settings.invoice_usdt_address, which is what this
       * component used to read. Two reasons:
       *
       *  1. global_settings is one shared object assigned to every invoice in
       *     the month by AccountingDetailsView, so reading an address from it
       *     cannot distinguish one client from another.
       *  2. The API omits `payment` entirely for actors not entitled to see it
       *     (agents). A template-level fallback to the global address would
       *     quietly undo that and show an agent a confident, wrong address.
       *
       * So: no address means no payment block. Absent beats plausible-but-wrong
       * when the subject is where money goes.
       */
      address () {
        return (this.invoice && this.invoice.payment)
          ? this.invoice.payment.usdt_address
          : null
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '@/sass/styles.vars.all.sass'

  .InvoicePayment
    break-after: avoid-page
    padding: $spacer $spacer-5
    font-size: .9em

    h3
      font-size: 1.4em
      text-transform: uppercase

    h4
      font-size: 1.2em
      color: $gray-700

  .InvoicePayment__cryptos
    h3
      display: flex
      align-items: center

      img
        height: 20px
        margin-left: 10px
        margin-top: -.2em

    em
      font-style: normal
      color: $primary
      font-family: monospace
      display: block
</style>

<style lang="sass">
  .InvoicePayment__accounts b
      margin-right: .5em
</style>
